export default __webpack_public_path__ + "static/media/url.d3688bda.svg";